import { AppRoute } from 'src/app/app.routes.fixtures'
import { Environment } from './environment.model'

export const environment: Environment = {
  production: false,
  appScheme: 'sciper://',
  apiBasePath: 'https://api-dev.sciper.eu',
  chatBasePath: 'https://chat-dev.sciper.eu/api/v1',
  chatWssPath: 'wss://chat-dev.sciper.eu/websocket',
  configId: 'sciper-dev',
  oauthConfig: {
    configurationUri:
      'https://api-dev.sciper.eu/auth/realms/sciper/.well-known/openid-configuration',
    // URL of the SPA to redirect the user to after login
    redirectUri: `${window.location.origin}/${AppRoute.welcomeOrientation}`,

    // URL of the SPA to redirect the user to after logout
    postLogoutRedirectUri: `${window.location.origin}/${AppRoute.intro}?client_id=sciper`,

    postAccountDeletionRedirectUri: `${window.location.origin}/${AppRoute.deleteAccount}`,

    accountDeletionUrl:
      'https://api-dev.sciper.eu/auth/realms/sciper/protocol/openid-connect/auth?response_type=code&client_id=sciper&kc_action=delete_account',

    userAccountUri: 'https://api-dev.sciper.eu/auth/realms/sciper/account/',

    clientId: 'sciper',

    responseType: 'code',

    // API scopes
    scope: 'openid email profile roles offline_access job.read job.write',

    showDebugInformation: false,
  },
  firebase: {
    apiKey: 'AIzaSyCkc7vwZCVD6jcathB9bLROhQ_DpqvKFzg',
    authDomain: 'sciper-app.firebaseapp.com',
    projectId: 'sciper-app',
    storageBucket: 'sciper-app.firebasestorage.app',
    messagingSenderId: '28455981949',
    appId: '1:28455981949:web:f5af74bcc2ecd64d753214',
    measurementId: 'G-Y4DDCN0ZNG',
  },
}
